// PackageEditor satır içi bantları (DR4/DR6/DR12/DR20): salt okunur notu, 409 KPI_PACKAGE_STALE
// bandı ("yeniden yükle" — taslak korunur), hata kutusu, yeniden uygulama notu, kayıt sonucu
// (`aria-live`, 6 sn) ve TEK amber uyarı satırı (P2): kullanımdan kalkmış kalem + eksik kırılım
// üyesi sayıları, "Göster" (Uyarılı süzgecini açar) ve "Üyeleri ekle". Amber token'larıyla.

import { KPI_PACKAGES_COPY } from "../../lib/kpi-packages-copy";
import { amberBox, decisionText, errorBox, footerBtn, helpText } from "./kpi-form-styles";

const C = KPI_PACKAGES_COPY;

export interface SaveResult {
  deps: number;
  sets: number;
  autoAdded: string | null;
}

export interface PackageEditorBandsProps {
  readOnlyReason: string | null;
  stale: boolean;
  /** kayıt başarılı, ardından yeniden okuma başarısız */
  reloadFailed?: boolean;
  reloading: boolean;
  onReload: () => void;
  saveError: string | null;
  notice: string | null;
  saved: SaveResult | null;
  deprecatedCount: number;
  /** "Uyarılı" süzgeci açık */
  warningFilterOn: boolean;
  onToggleWarningFilter: () => void;
  missingCount: number;
  /** null → düzenlenemez (düğme yok) */
  onAddMissing: (() => void) | null;
}

export function PackageEditorBands(p: PackageEditorBandsProps): JSX.Element {
  return (
    <>
      {p.readOnlyReason ? <p style={{ ...helpText, margin: 0 }}>{p.readOnlyReason}</p> : null}
      {p.stale || p.reloadFailed === true ? (
        <div
          role="alert"
          style={amberBox}
          className="flex flex-wrap items-center gap-2"
          data-testid={p.stale ? "package-stale" : "package-reload-failed"}
        >
          <span className="flex-1">{p.stale ? C.page.stale : C.page.savedReloadFailed}</span>
          <button type="button" style={footerBtn()} disabled={p.reloading} onClick={p.onReload}>
            {C.page.reload}
          </button>
        </div>
      ) : null}
      {p.saveError ? (
        <div role="alert" data-alert-variant="error" style={errorBox}>
          {p.saveError}
        </div>
      ) : null}
      {p.notice ? (
        <p role="status" style={{ ...helpText, margin: 0 }}>
          {p.notice}
        </p>
      ) : null}
      <div aria-live="polite">
        {p.saved ? (
          <p
            style={{ ...decisionText, color: "var(--color-primary-text)", margin: 0 }}
            data-testid="package-saved"
          >
            {C.page.saved(p.saved.deps, p.saved.sets)}
            {p.saved.autoAdded ? (
              <span style={{ ...helpText, display: "block" }}>{p.saved.autoAdded}</span>
            ) : null}
          </p>
        ) : null}
      </div>
      {p.deprecatedCount > 0 || p.missingCount > 0 ? (
        <div
          style={amberBox}
          className="flex flex-wrap items-center gap-2"
          data-testid="package-warning-band"
        >
          <span className="flex-1">
            {[
              p.deprecatedCount > 0 ? C.errors.KPI_PACKAGE_HAS_DEPRECATED(p.deprecatedCount) : null,
              p.missingCount > 0 ? C.page.missingMembers(p.missingCount) : null,
            ]
              .filter((x): x is string => x !== null)
              .join(" · ")}
          </span>
          <button
            type="button"
            style={footerBtn()}
            aria-pressed={p.warningFilterOn}
            onClick={p.onToggleWarningFilter}
          >
            {p.warningFilterOn ? C.bands.hide : C.bands.show}
          </button>
          {p.missingCount > 0 && p.onAddMissing ? (
            <button type="button" style={footerBtn()} onClick={p.onAddMissing}>
              {C.page.addMissingMembers}
            </button>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
